import { jWebReady, jWebStates } from './initializer';


import {
  JWebType,
  PutKeyValueOption,
  ValueStorePlugin,
  DataCollectionPlugin,
  DataCollectionService,
} from "./types";
import * as JWebEnumsImport from './JWebEnums';
// eslint-disable-next-line no-restricted-imports
import { getDataCollectionService as getDataCollectionServiceImport } from '@jarvis/web-data-collection';

export { getEventServicePlugin } from "./eventService";

export const JWebEnums = JWebEnumsImport;

export function JWebErrorHandler<T>(object: Record<string, any>): T {
  if (object?.errorType) {
    throw new Error(`JWeb: ${object?.errorType} - ${object?.reason}`);
  }
  return object as T;
}

export async function getJWeb(): Promise<JWebType> {
  await jWebReady;
  return (window as any)?.JWeb;
}

export async function isNative(): Promise<boolean> {
  return (await getJWeb())?.isNative || false;
}

export async function writeDataToValueStore(
  entriesValue: Array<PutKeyValueOption>
): Promise<void> {
  try {
    // Is Jweb ready?
    await jWebStates.JWebLibrary;
    // Is the plugins registered?
    await jWebStates.defaultPluginsRegistered;
    // Was valueStore installed?
    await jWebStates.plugins.ValueStore;
    // request current valueStore.
    const valueStore = await getValueStorePlugin();
    if (valueStore) {
      valueStore.put({
        entries: entriesValue,
      });
    }
  } catch (e) {
    console.error("Unable to write in Value Store. JWeb failed.");
  }
}

export async function getValueStorePlugin(): Promise<ValueStorePlugin> {
  const windowValueStore: ValueStorePlugin = (window as any)?.JWeb?.Plugins
    ?.ValueStore;
  if (!windowValueStore) {
    console?.error("Unable to obtain ValueStore (missing some JWeb plugin)");
  }
  return windowValueStore;
}

export async function getDataCollectionService(): Promise<
  DataCollectionService | any
> {
  if (!(await isNative())) {
    // Was DataCollection installed?
    await jWebStates.plugins.DataCollection;
    return await getDataCollectionServiceImport();
  }
  return undefined;
}

export async function getDataCollectionPlugin(): Promise<DataCollectionPlugin> {
  const windowDataCollection: DataCollectionPlugin = (window as any)?.JWeb
    ?.Plugins?.DataCollection;
  if (!windowDataCollection) {
    console?.error(
      "Unable to obtain DataCollection (missing some JWeb plugin)"
    );
  }
  return windowDataCollection;
}
